import { render } from "./OrderDecisions.vue?vue&type=template&id=b56de8b6&scoped=true"
import script from "./OrderDecisions.vue?vue&type=script&lang=js"
export * from "./OrderDecisions.vue?vue&type=script&lang=js"

import "./OrderDecisions.vue?vue&type=style&index=0&id=b56de8b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56de8b6"],['__file',"src/views/OrderDecisions/OrderDecisions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b56de8b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b56de8b6', __exports__)) {
    api.reload('b56de8b6', __exports__)
  }
  
  module.hot.accept("./OrderDecisions.vue?vue&type=template&id=b56de8b6&scoped=true", () => {
    api.rerender('b56de8b6', render)
  })

}


export default __exports__